import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { makesQueries } from 'data/graphql'
import { selectors as ConfigSelectors } from 'data/config'
import CookiesHelpers from 'helpers/Cookies'

const COOKIE_NAME = 'SLITE_PUBLIC_PAGES_AB_FLAGS'

const publicPagesABFlagsQuery = gql`
  query getPublicPagesABFlags {
    getPublicPagesABFlags
  }
`

const providesPublicPagesABFlags = compose(
  connect(state => ({
    cookieDomain: ConfigSelectors.getCookieDomain(state),
  })),
  makesQueries({
    query: publicPagesABFlagsQuery,
    getOnResultFromProps: ({ cookieDomain }) => ({ result }) => {
      if (!CookiesHelpers.get(COOKIE_NAME)) {
        CookiesHelpers.set(COOKIE_NAME, result.data.getPublicPagesABFlags, {
          domain: cookieDomain,
        })
      }
    },
  })
)

export default providesPublicPagesABFlags
